import * as React from 'react';
import { Section } from './Section';
import { Col } from '../bootstrap-components/BootstrapComponents';
import { Clearfix } from './Clearfix';

export interface SectionAfsnitProps {
    header?: string;
    subHeader?: string;
    children?: any;
}

export default class SectionAfsnit extends React.Component < SectionAfsnitProps,
any > {
    constructor(props: SectionAfsnitProps) {
        super(props);
    }

    getHeader() {
        if (this.props.header !== undefined) {
            return <h1>{this.props.header}</h1>;
        }

        return;
    }

    getSubHeader() {
        if (this.props.subHeader !== undefined) {
            return <h2>{this.props.subHeader}</h2>;
        }

        return;
    }

    render() {
        return (
            <Section className='section-afsnit'>
                <Col md={3} className='section-afsnit-header-col'>
                    {this.getHeader()}
                    {this.getSubHeader()}
                </Col>
                <Col md={8} className='section-afsnit-content-col'>
                    {this.props.children}
                </Col>
                <Clearfix />
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionAfsnit.tsx